<template>
  <div class="date-range-mobile-container">
    <input-container
      :label="$t('searchBar.checkInAndOut')"
      :src="calendarIcon"
      class="min-date-width"
      :class="{ plain }"
      data-cy="checkin-checkout"
      @click="openModal"
      ><span class="date-text" @click="openModal">{{ dateRangeFormatted }}</span>
    </input-container>
    <calendar-modal
      id="search-bar-calendar-modal"
      :config="datePickerConfig"
      :value="dateRangeFormatted"
      @on-change="onChange"
      @close="closeModal"
    ></calendar-modal>
  </div>
</template>

<script>
import InputContainer from 'components/InputContainer'
import calendarIcon from 'assets/icons/calendar-gray.svg'
import { calendarTranslation } from 'locales/utilities'
import { dateOfToday } from 'utilities/date'
import DateRangeFormatMixin from './DateRangeFormatMixin'
import CalendarModal from 'components/Common/CalendarModal'
import { scrollToTop } from 'utilities/domOperation'

export default {
  name: 'DateRangePickerMobile',

  components: {
    InputContainer,
    CalendarModal
  },

  mixins: [DateRangeFormatMixin],

  props: {
    config: {
      type: Object,
      required: true
    },
    value: {
      type: [Array, Date, String],
      required: true
    },
    plain: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      calendarIcon
    }
  },

  computed: {
    datePickerConfig() {
      return {
        minDate: dateOfToday(),
        maxDate: null,
        dateFormat: 'Y/m/d',
        locale: {
          ...calendarTranslation(this.$i18n.locale),
          rangeSeparator: ' - '
        },
        ...this.config,
        ...this.$attrs,
        onReady: this.config.onOpen
      }
    }
  },

  methods: {
    onChange(dateRange) {
      this.$emit('input', dateRange.split(this.datePickerConfig.locale.rangeSeparator))
      setTimeout(() => {
        scrollToTop()
      }, 500)
    },
    closeModal() {
      // reset room plan code when modal close
      this.$store.dispatch('search/setSearchForm', {
        selectedRoomPlanCode: null
      })
    },
    openModal() {
      this.$bvModal.show('search-bar-calendar-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~stylesheets/vars.scss';
.header {
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;

  &.orange {
    color: $clementine;
  }

  .icon {
    overflow: visible;

    &.orange {
      fill: $clementine;
    }
  }
}

.plain {
  :deep(.slot) {
    padding: 0;
  }

  .date-text {
    border: 1px solid #ced4da;
    margin: 7px 0 10px;
    border-radius: 0.25rem;
    height: calc(1.5em + 0.75rem + 2px);
    width: 100%;
    padding: 5px 0 0 15px;
    text-decoration: none;
    display: inline-block;
  }
}
</style>
